module.exports = __webpack_public_path__ + "media/chat-notification.211308b8.mp3";